const config = {
    PROJECT_X_URL : 'https://app.shipsy.in',
    GOOGLE_RECAPTCHA_SITE_KEY : '6Ld8BOQUAAAAAHjZ7AyFHmMUlr1gyXjyXFER9GYX',
    ORGANISATION_LOGO_URL : 'https://s3-us-west-2.amazonaws.com/shipsy-public-assets/Zajil/Zajil.jpg',
    applicationType : 'zajilebooking',
    hardcodedDataOrgs: ['ZAJIL'],
    hideAreaCodeOrgs: ['FLOWPL', 'epickmeup'],
};
export default config;
